import * as _ from 'lodash';
import { Column, Formatter, FormatterEx, SlickGrid } from 'slickgrid';

function getCellValue<T>(
  row: number,
  cell: number,
  value: any,
  columnDef: Column<T>,
  data: T,
  grid: SlickGrid,
) {
  if (columnDef.displayMember) {
    value = data[columnDef.displayMember];
  }

  return value == null ? '' : value;
}

export function clicksink<T>(): Formatter<T> {
  const clicksinkFormatter: FormatterEx<T> = (
    row,
    cell,
    value,
    columnDef,
    data,
    grid,
  ) => {
    return `<a href='#' onclick='return false;'>
  ${getCellValue(row, cell, value, columnDef, data, grid)}
</a>`;
  };

  clicksinkFormatter.exportRawData = true;

  return clicksinkFormatter;
}
